<script lang="ts">
	import Card from '@smui/card';
	import Select, { Option } from '@smui/select';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import StepWizard from 'svelte-step-wizard';
	import { writable } from 'svelte/store';
	import ContainerLoading from '../../../../../shared/components/common/Loading/ContainerLoading.svelte';
	import FieldLoading from '../../../../../shared/components/common/Loading/FieldLoading.svelte';
	import FormLoading from '../../../../../shared/components/common/Loading/FormLoading.svelte';
	import NoDataAvailable from '../../../../../shared/components/common/NoDataAvailable.svelte';
	import SurveyReport from '../../../../../shared/components/common/Survey/SurveyReport.svelte';
	import TitleCard from '../../../../../shared/components/common/Title.svelte';
	import TabellaCalcoloEmissioniInput from '../../../../../shared/components/mobilityPlatform/CalcoloEmissioni/TabellaCalcoloEmissioniInput.svelte';
	import TabellaCalcoloEmissioniOutput from '../../../../../shared/components/mobilityPlatform/CalcoloEmissioni/TabellaCalcoloEmissioniOutput.svelte';
	import GraficoOrdinamentoCategorieMisura from '../../../../../shared/components/mobilityPlatform/PSCL/GraficoOrdinamentoCategorieMisura.svelte';
	import TabellaImplementazioneMisure from '../../../../../shared/components/mobilityPlatform/PSCL/TabellaImplementazioneMisure.svelte';
	import TabellaMisure from '../../../../../shared/components/mobilityPlatform/PSCL/TabellaMisure.svelte';
	import TabellaMonitoraggioMisure from '../../../../../shared/components/mobilityPlatform/PSCL/TabellaMonitoraggioMisure.svelte';
	import TabellaProgrammaComunicazione from '../../../../../shared/components/mobilityPlatform/PSCL/TabellaProgrammaComunicazione.svelte';
	import TabellaProgrammaMonitoraggio from '../../../../../shared/components/mobilityPlatform/PSCL/TabellaProgrammaMonitoraggio.svelte';
	import TabellaAltreInfo from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaAltreInfo.svelte';
	import TabellaAreeSostaRiservate from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaAreeSostaRiservate.svelte';
	import TabellaCapComuneDipendenti from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaCapComuneDipendenti.svelte';
	import TabellaIncentiviBuoniMobilita from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaIncentiviBuoniMobilita.svelte';
	import TabellaLocalizzazione from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaLocalizzazione.svelte';
	import TabellaOffertaTrasporto from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaOffertaTrasporto.svelte';
	import TabellaOrarioLavoro from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaOrarioLavoro.svelte';
	import TabellaPersonaleDipendente from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaPersonaleDipendente.svelte';
	import TabellaRisorseGestioneMobilita from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaRisorseGestioneMobilita.svelte';
	import TabellaServiziTrasporto from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaServiziTrasporto.svelte';
	import TabellaStrumentiComunicazione from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaStrumentiComunicazione.svelte';
	import TabellaTipologieLavoratori from '../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaTipologieLavoratori.svelte';
	import PSCLElaborazione from '../../../../../shared/models/PSCL/Elaborazione/PSCLElaborazione';
	import { PSCLSchemaBase } from '../../../../../shared/models/PSCL/Schema/PSCLSchemaBase';
	import { PSCLSchemaSede } from '../../../../../shared/models/PSCL/Schema/PSCLSchemaSede';
	import Questionario from '../../../../../shared/models/Questionario/Questionario';
	import Sede from '../../../../../shared/models/Sede/Sede';
	import Map from './Map.svelte';
	import QuestionarioRisposte from '../../../../../shared/models/Questionario/QuestionarioRisposte';
	import StimulsoftReport from '../../../../../shared/components/common/StimulsoftReport.svelte';

    export let params = {
		id: '0',
	};

	let stringifiedQuestionarioJson = '';
	let stringifiedQuestionarioJsonUpdated = '';
	let risposteJson = [];
	let risposteJsonUpdated = [];

	let stringifiedQuestionarioJsonAnalisi = '';
	let risposteJsonAnalisi = [];
	let stringifiedQuestionarioJsonAppendice = '';
	let risposteJsonAppendice = [];
    
    let [data, loading, error] = PSCLSchemaSede.get(params.id);
	let [dataReport, loadingReport, errorReport] = [null, null, null];
	let [dataPSCLSchemaInizializzazione, loadingPSCLSchemaInizializzazione, errorPSCLSchemaInizializzazione] = [null, null, null];
	let [dataQuestionarioPerReportGrafici, loadingQuestionarioPerReportGrafici, errorQuestionarioPerReportGrafici] = [writable(null), writable(false), writable(null)];

	if (params.id == '0') {
		let [dataPSCLSchemaBase, loadingPSCLSchemaBase, errorPSCLSchemaBase] = PSCLSchemaBase.get();
		dataPSCLSchemaBase.subscribe((value) => {
			Object.assign($data, value);
			$data.id = 0;
			$data.psclSchemaIntroduzione.id = 0;
			$data.psclSchemaIntroduzione.psclSchemaBaseId = undefined;
			$data.psclSchemaAnalisi.id = 0;
			$data.psclSchemaAnalisi.psclSchemaBaseId = undefined;
			$data.psclSchemaProgettazione.id = 0;
			$data.psclSchemaProgettazione.psclSchemaBaseId = undefined;
			$data.psclSchemaMonitoraggio.id = 0;
			$data.psclSchemaMonitoraggio.psclSchemaBaseId = undefined;
			$data.psclSchemaAppendice.id = 0;
			$data.psclSchemaAppendice.psclSchemaBaseId = undefined;
			$data.psclSchemaMonitoraggioMisureId = 0;
			$data.psclSchemaMonitoraggioMisure.psclSchemaBaseId = undefined;
		});
	}

	data?.subscribe((value) => {
		if (value && value.questionario) {
			stringifiedQuestionarioJson = value.questionario.questionarioJson;
		}
	});

	let hasLoadedQuestionarioRisposte = false;
	let loadingQuestionarioRisposte = false;

	$: {
		if ($data?.psclElaborazione?.questionarioId && !$loading && !hasLoadedQuestionarioRisposte) {
			loadQuestionarioRisposte($data.psclElaborazione.questionarioId);
		}
	}

	async function loadQuestionarioRisposte(questionarioId: string) {
		if (!hasLoadedQuestionarioRisposte && !loadingQuestionarioRisposte) {
			loadingQuestionarioRisposte = true;
			try {
				const jsonData = await QuestionarioRisposte.getListByQuestionarioId(
					questionarioId, 
					$data.sedeId.toString()
				);
				
				if (jsonData?.response) {
					$data.questionarioRisposte = jsonData.response.risposte;
					$data.questionario = jsonData.response.questionario;
					stringifiedQuestionarioJson = jsonData.response.questionario.questionarioJson;
					
					if (jsonData.response.risposte?.length > 0) {
						risposteJson = jsonData.response.risposte.map((risposta) => 
							JSON.parse(risposta.questionarioRisposteJson)
						);
						
						if (stringifiedQuestionarioJson && risposteJson.length > 0) {
							[dataQuestionarioPerReportGrafici, loadingQuestionarioPerReportGrafici, errorQuestionarioPerReportGrafici] = 
								Questionario.prepareSurveyForGraphicReports(
									stringifiedQuestionarioJson, 
									JSON.stringify(risposteJson)
								);

							dataQuestionarioPerReportGrafici.subscribe((preparedData) => {
								if (preparedData?.response) {
									stringifiedQuestionarioJsonAnalisi = preparedData.response.questionarioAnalisiJsonStringified;
									risposteJsonAnalisi = preparedData.response.risposteAnalisi;
								}
							});
						}
					}
				}
				hasLoadedQuestionarioRisposte = true;
			} catch (error) {
				console.error('Errore nel caricamento del questionario:', error);
			} finally {
				loadingQuestionarioRisposte = false;
			}
		}
	}

    let [dataSedi, loadingSedi, errorSedi] = Sede.getList();
	let [dataPSCLElaborazione, loadingPSCLElaborazione, errorPSCLElaborazione] = PSCLElaborazione.getList();

	let selectedSede: Sede = new Sede();
	$: selectedSede = $data.sede;

	let selectedPSCLElaborazione: PSCLElaborazione | undefined = undefined;
	$: selectedPSCLElaborazione = $data.psclElaborazione;

	let selectedPSCLElaborazioneMisureApplicate: PSCLElaborazione | undefined = undefined;
    $: selectedPSCLElaborazioneMisureApplicate = $data.psclElaborazioneMisureApplicate;
	
	$:  {
		if ($data.questionarioRisposte?.length > 0) {
			risposteJson = $data.questionarioRisposte?.map((risposta) => JSON.parse(risposta.questionarioRisposteJson));
			if (stringifiedQuestionarioJson && stringifiedQuestionarioJson !== "" && risposteJson.length > 0) {
				[dataQuestionarioPerReportGrafici, loadingQuestionarioPerReportGrafici, errorQuestionarioPerReportGrafici] = Questionario.prepareSurveyForGraphicReports(stringifiedQuestionarioJson, JSON.stringify(risposteJson));
			}
		}
	}
	
	$: {
		if($dataQuestionarioPerReportGrafici?.response) {
			if ($dataQuestionarioPerReportGrafici?.response?.questionarioJsonStringified) {
				stringifiedQuestionarioJsonUpdated = $dataQuestionarioPerReportGrafici?.response?.questionarioJsonStringified;
			}
			if ($dataQuestionarioPerReportGrafici?.response?.risposte) {
				risposteJsonUpdated = [...$dataQuestionarioPerReportGrafici?.response?.risposte];
			}
			if ($dataQuestionarioPerReportGrafici?.response?.questionarioAnalisiJsonStringified) {
				stringifiedQuestionarioJsonAnalisi = $dataQuestionarioPerReportGrafici?.response?.questionarioAnalisiJsonStringified;
			}
			if ($dataQuestionarioPerReportGrafici?.response?.risposteAnalisi) {
				risposteJsonAnalisi = [...$dataQuestionarioPerReportGrafici?.response?.risposteAnalisi];
			}
			if ($dataQuestionarioPerReportGrafici?.response?.questionarioAppendiceJsonStringified) {
				stringifiedQuestionarioJsonAppendice = $dataQuestionarioPerReportGrafici?.response?.questionarioAppendiceJsonStringified;
			}
			if ($dataQuestionarioPerReportGrafici?.response?.risposteAppendice) {
				risposteJsonAppendice = [...$dataQuestionarioPerReportGrafici?.response?.risposteAppendice];
			}
		}
	}

	$: isSelectedPSCLElaborazioneMisureApplicateEnabled = $data.psclElaborazioneId > 0;

	function getFilteredPSCLElaborazioni(elaborazioni, selectedElaborazioneId, selectedElaborazioneDate) {
		if (!elaborazioni || !selectedElaborazioneId || !selectedElaborazioneDate) return [];
		
		return elaborazioni.filter(elaborazione => 
			elaborazione.id !== selectedElaborazioneId && 
			new Date(elaborazione.dataInsert) < new Date(selectedElaborazioneDate)
		);
	}
	
	let map;
	let surveyReport;
	let loadingScreenshots = false;

	function onInit() {
		[dataPSCLSchemaInizializzazione, loadingPSCLSchemaInizializzazione, errorPSCLSchemaInizializzazione] = PSCLSchemaSede.init(
				$data.sedeId.toString(), 
				$data.psclElaborazioneId.toString(), 
				$data.psclElaborazioneMisureApplicateId ? $data.psclElaborazioneMisureApplicateId.toString() : '0'
			);
		dataPSCLSchemaInizializzazione.subscribe((value) => {
			const PSCLSchemaSedeDescrizione = $data.descrizione;
			Object.assign($data, value);
			$data.descrizione = PSCLSchemaSedeDescrizione;
			[dataPSCLElaborazione, loadingPSCLElaborazione, errorPSCLElaborazione] = PSCLElaborazione.getList({ sedeId: $data.sedeId });
		});
	}

	function onSubmit() {
		var psclSchema = {
			id: $data.id,
			descrizione: $data.descrizione,
			sedeId: $data.sedeId,
			psclElaborazioneId: $data.psclElaborazioneId,
			psclElaborazioneMisureApplicateId: $data.psclElaborazioneMisureApplicateId,
			psclSchemaAnalisi: $data.psclSchemaAnalisi,
			psclSchemaAppendice: $data.psclSchemaAppendice,
			psclSchemaMonitoraggioMisure: $data.psclSchemaMonitoraggioMisure,
		};
		[dataReport, loadingReport, errorReport] = PSCLSchemaSede.save(psclSchema);
		//console.log($dataReport);
	}

	// Funzione per generare il report Word direttamente
	async function generateWordReport() {
		try {
			loadingScreenshots = true;
			
			// Cattura prima tutte le screenshot necessarie
			if (map) {
				await map.getMapScreenshot();
			}
			
			if (surveyReport) {
				await surveyReport.getPlotsScreenshots();
			}
			
			// Salva prima il PSCL per assicurarsi che tutte le informazioni siano aggiornate
			await onSubmit();
			
			// Poi scarica il report Word
			if ($data && $data.id) {
				const response = await fetch(`/api/psclschemasede/word/${$data.id}`, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
					},
				});
				
				if (!response.ok) {
					throw new Error('Errore durante la generazione del report Word');
				}
				
				// Gestisci il download del file
				const blob = await response.blob();
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.style.display = 'none';
				a.href = url;
				a.download = `PSCL_${new Date().toISOString().slice(0,10)}.docx`;
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
			}
		} catch (error) {
			console.error('Errore nella generazione del report Word:', error);
			// Mostra un messaggio di errore all'utente
			alert('Si è verificato un errore durante la generazione del report Word.');
		} finally {
			loadingScreenshots = false;
		}
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<TitleCard title="Stampa piano" />
	</div>
	{#if $loading}
		<FormLoading customClass="pt-8" />
	{:else}
		{#if $data}
            <StepWizard initialStep="{1}">
                <StepWizard.Step num="{1}" let:nextStep>
                    <div class="grid grid-cols-1 px-4 pt-4">
                        <div class="flex col-start-2" style="text-align: end">
                            <button
                                disabled="{$data.sedeId == 0 || !$data.descrizione}"
                                type="button"
                                class="btn-white h-14 w-14 sm:h-16 sm:w-16"
                                on:click="{nextStep}"
                            >
                                <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
                            </button>
                        </div>
                    </div>
                    <span class="p-4">{$_('page.pscl.detail.initial_info')}</span>
                    <div class="md:grid-cols-3 grid grid-cols-1">
                        <Input label="Nome PSCL" bind:value="{$data.descrizione}" class="md:col-start-2" required />
                        {#if $loadingSedi || $loadingPSCLSchemaInizializzazione}
                            <FieldLoading customClass="md:col-start-2" />
                        {:else}
                            <Select
                                disabled="{$data.id > 0}"
                                label="Sede"
                                key="{(sede) => `${(sede && sede.id) || ''}`}"
                                bind:value="{selectedSede}"
                                class="md:col-start-2"
                                required
                            >
                                {#if $dataSedi.response}
                                    {#each $dataSedi.response as sede (sede.id)}
                                        {#if sede.denominazione}
                                            <Option
                                                value="{sede}"
                                                on:click="{() => {
                                                    $data.sedeId = sede.id;
													onInit();
													$data.sede = sede;
													
                                                }}">{sede.denominazione}</Option
                                            >
                                        {/if}
                                    {/each}
                                {/if}
                            </Select>
                        {/if}
						{#if $loadingPSCLElaborazione || $loadingPSCLSchemaInizializzazione}
							<FieldLoading customClass="md:col-start-2" />
						{:else}
							<Select
								disabled="{$data.id > 0 || !$data.sedeId || $data.sedeId == 0}"
								label="Misure anno corrente"
								key="{(psclElaborazione) => `${(psclElaborazione && psclElaborazione?.id) || ''}`}"
								class="md:col-start-2 w-full"
								bind:value="{selectedPSCLElaborazione}"
								required
							>
								{#if $dataPSCLElaborazione?.response}
									{#each $dataPSCLElaborazione.response as psclElaborazione (psclElaborazione?.id)}
										{#if psclElaborazione?.descrizione}
											<Option
												value="{psclElaborazione}"
												on:click="{() => {
													$data.psclElaborazioneId = psclElaborazione.id;
													$data.psclElaborazione = psclElaborazione;
													$data.psclElaborazioneMisureApplicateId = undefined;
													$data.psclElaborazioneMisureApplicate = undefined;
													onInit();
												}}">{psclElaborazione.descrizione}</Option>
										{/if}
									{/each}
								{/if}
							</Select>
						{/if}
						{#if $loadingPSCLElaborazione || $loadingPSCLSchemaInizializzazione}
							<FieldLoading customClass="md:col-start-2" />
						{:else}
							<Select
								disabled="{$data.id > 0 || !$data.sedeId || $data.sedeId == 0 || !isSelectedPSCLElaborazioneMisureApplicateEnabled}"
								label="Misure anno precedente"
								key="{(psclElaborazione) => `${(psclElaborazione && psclElaborazione?.id) || ''}`}"
								class="md:col-start-2 w-full"
								bind:value="{selectedPSCLElaborazioneMisureApplicate}"
							>
								<Option value={undefined}></Option>
								{#if $dataPSCLElaborazione?.response}
									{#each getFilteredPSCLElaborazioni($dataPSCLElaborazione.response, $data.psclElaborazioneId, $data.psclElaborazione?.dataInsert) as psclElaborazione (psclElaborazione?.id)}
										<Option
											value="{psclElaborazione}"
											on:click="{() => {
												$data.psclElaborazioneMisureApplicateId = psclElaborazione.id;
												onInit();
												$data.psclElaborazioneMisureApplicate = psclElaborazione;
											}}">{psclElaborazione.descrizione}</Option>
									{/each}
								{/if}
							</Select>
						{/if}
                    </div>
                </StepWizard.Step>
                <StepWizard.Step num="{2}" let:previousStep let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-start col-start-1">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
							</button>
						</div>
						<div class="justify-self-end col-start-2">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
							</button>
						</div>
					</div>
					<div class="p-10 h-[70vh]">
						<div class="border-mobilityPlatform-green relative flex flex-col items-center justify-center h-full p-4 pb-20 border-t-2 border-b-2">
							<div class="flex flex-col items-center justify-center space-y-4">
								<div class="text-center">
									<span class="text-xl font-bold"><span>{$data?.aziendaEnte?.nomeAziendaEnte}</span> - <span>{$data?.sede?.denominazione}</span></span>
								</div>
								<div class="text-center">
									<span class="text-lg">Piano degli Spostamenti Casa-Lavoro</span>
								</div>
								<div class="mt-28 self-end w-full text-center">
								<p class="text-sm">
									{#if $data?.dataInsert}
										<span>{(new Date($data?.dataInsert).getMonth() + 1).toString().padStart(2, '0')}/{new Date($data?.dataInsert).getFullYear()}</span>
									{/if}
								</p>
								</div>
							</div>
							<div class="min-w-max absolute bottom-0 right-0 flex flex-col p-4 text-xs">
								<p class="text-base">A cura di</p>
								<p>{$data?.nomeMobilityManager} {$data?.cognomeMobilityManager}</p>
								<p>Mobility manager {$data?.aziendaEnte?.nomeAziendaEnte}</p>
								<p>{$data.psclSchemaIntroduzione.testoPrimaPagina}</p>
							</div>
						</div>
					</div>
				</StepWizard.Step>
				<StepWizard.Step num="{3}" let:previousStep let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-start col-start-1">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
							</button>
						</div>
						<div class="justify-self-end col-start-2">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
							</button>
						</div>
					</div>
					<div class="flex flex-col items-start justify-start p-4 mr-2">
						<h1 class="text-3xl italic font-bold">
							<span>1.</span>
							<span>Introduzione</span>
						</h1>
						<div class="w-full mt-4">
							<p>{$data.psclSchemaIntroduzione.testoIntroduzione}</p>
						</div>
					</div>
				</StepWizard.Step>
				<StepWizard.Step num="{4}" let:previousStep let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-start col-start-1">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
							</button>
						</div>
						<div class="justify-self-end col-start-2">
							<button disabled={loadingScreenshots} type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" 
							on:click={async () => {
								if (!loadingScreenshots) {
									loadingScreenshots = true;
									try {
										await Promise.all([
											map.getMapScreenshot(),
											surveyReport?.getPlotsScreenshots()
										]);
										nextStep();
									} finally {
										loadingScreenshots = false;
									}
								}
								}}>
								{#if loadingScreenshots}
									<span class="material-icons-outlined animate-spin">refresh</span>
								{:else}
									<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
								{/if}
							</button>
						</div>
					</div>
					<div class="flex flex-col items-start justify-start p-4 ml-2">
						<h1 class="text-3xl italic font-bold">
							<span>2.</span>
							<span>Parte informativa e di analisi</span>
						</h1>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>2.1</span>
								<span>Analisi delle condizioni strutturali dell'azienda e dell'offerta di trasporto</span>
							</h1>
							<p>{$data.psclSchemaAnalisi.testoCondizioniStrutturali}</p>
							<div class="flex justify-center mt-2">
								<div class="w-full">
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Localizzazione</h2>
										<TabellaLocalizzazione data={$data?.sede}/>
									</div>
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Personale dipendente</h2>
										<TabellaPersonaleDipendente data={$data?.sede} />
									</div>
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Tipologie lavoratori</h2>
										<TabellaTipologieLavoratori data={$data?.sede?.sedeTipologieLavoratori} />
									</div>
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Orario di lavoro</h2>
										<TabellaOrarioLavoro data={$data?.sede?.sedeAltreInfo} />
									</div>
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Risorse, servizi e dotazioni aziendali</h2>
										<h3 class="mb-2 text-xs text-center">Risorse per la gestione della mobilità dei dipendenti</h3>
										<TabellaRisorseGestioneMobilita data={$data?.sede?.sedeAltreInfo} />
										<h3 class="mt-2 mb-2 text-xs text-center">Servizi di trasporto per i dipendenti</h3>
										<TabellaServiziTrasporto data={$data?.sede?.sedeDotazioniServizi}/>
										<h3 class="mt-2 mb-2 text-xs text-center">Incentivi / buoni mobilità per i dipendenti</h3>
										<TabellaIncentiviBuoniMobilita data={$data?.sede?.sedeDotazioniServizi}/>
										<h3 class="mt-2 mb-2 text-xs text-center">Aree di sosta riservate ai dipendenti</h3>
										<TabellaAreeSostaRiservate data={$data?.sede?.sedeDotazioniServizi}/>
										<h3 class="mt-2 mb-2 text-xs text-center">Altro</h3>
										<TabellaAltreInfo data={$data?.sede?.sedeDotazioniServizi} />
									</div>
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Strumenti di comunicazione</h2>
										<TabellaStrumentiComunicazione data={$data?.sede?.sedeStrumentiComunicazione} />
									</div>
								</div>
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>2.2</span>
								<span>Analisi dell'offerta di trasporto</span>
							</h1>
							<p>{$data.psclSchemaAnalisi.testoOffertaTrasporto}</p>
							<div class="flex justify-center mt-2">
								<div class="w-full">
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Offerta di trasporto nei pressi della sede (distanza max 500 m)</h2>
										<TabellaOffertaTrasporto data={$data.sede.sedeOffertaTrasporti} />
									</div>
								</div>
							</div>
							{#if $data.sede.sedeParagrafiAccessibilitaPSCL && $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiReteStradale && $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiReteStradale.length > 0}
								<div class="w-full mt-4 ml-2">
									<h1 class="text-2xl font-bold">
										<span>Rete Stradale</span>
									</h1>
									{#each $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiReteStradale as paragrafo}
										<div class="pb-4 mt-4 border-b border-gray-300">
											<p>{paragrafo.descrizione}</p>
											{#if paragrafo.allegatoSedeParagrafoReteStradale}
												<div class="flex justify-center mt-2">
													<img src={`data:${paragrafo.allegatoSedeParagrafoReteStradale.mimeType};base64,${paragrafo.allegatoSedeParagrafoReteStradale.documento}`} alt={paragrafo.allegatoSedeParagrafoReteStradale.nome} class="max-h-60 h-auto max-w-full" />
												</div>
											{/if}
										</div>
									{/each}
								</div>
							{/if}
							{#if $data.sede.sedeParagrafiAccessibilitaPSCL && $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiCiclabilita && $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiCiclabilita.length > 0}
								<div class="w-full mt-4 ml-2">
									<h1 class="text-2xl font-bold">
										<span>Ciclabilità</span>
									</h1>
									{#each $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiCiclabilita as paragrafo}
										<div class="pb-4 mt-4 border-b border-gray-300">
											<p>{paragrafo.descrizione}</p>
											{#if paragrafo.allegatoSedeParagrafoCiclabilita}
												<div class="flex justify-center mt-2">
													<img src={`data:${paragrafo.allegatoSedeParagrafoCiclabilita.mimeType};base64,${paragrafo.allegatoSedeParagrafoCiclabilita.documento}`} alt={paragrafo.allegatoSedeParagrafoCiclabilita.nome} class="max-h-60 h-auto max-w-full" />
												</div>
											{/if}
										</div>
									{/each}
								</div>
							{/if}
							{#if $data.sede.sedeParagrafiAccessibilitaPSCL && $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiTrasportoPubblico && $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiTrasportoPubblico.length > 0}
								<div class="w-full mt-4 ml-2">
									<h1 class="text-2xl font-bold">
										<span>Trasporto pubblico</span>
									</h1>
									{#each $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiTrasportoPubblico as paragrafo}
										<div class="pb-4 mt-4 border-b border-gray-300">
											<p>{paragrafo.descrizione}</p>
											{#if paragrafo.allegatoSedeParagrafoTrasportoPubblico}
												<div class="flex justify-center mt-2">
													<img src={`data:${paragrafo.allegatoSedeParagrafoTrasportoPubblico.mimeType};base64,${paragrafo.allegatoSedeParagrafoTrasportoPubblico.documento}`} alt={paragrafo.allegatoSedeParagrafoTrasportoPubblico.nome} class="max-h-60 h-auto max-w-full" />
												</div>
											{/if}
										</div>
									{/each}
								</div>
							{/if}
							{#if $data.sede.sedeParagrafiAccessibilitaPSCL && $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiMobilitaCondivisa && $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiMobilitaCondivisa.length > 0}
								<div class="w-full mt-4 ml-2">
									<h1 class="text-2xl font-bold">
										<span>Mobilità condivisa</span>
									</h1>
									{#each $data.sede.sedeParagrafiAccessibilitaPSCL.sedeParagrafiMobilitaCondivisa as paragrafo}
										<div class="pb-4 mt-4 border-b border-gray-300">
											<p>{paragrafo.descrizione}</p>
											{#if paragrafo.allegatoSedeParagrafoMobilitaCondivisa}
												<div class="flex justify-center mt-2">
													<img src={`data:${paragrafo.allegatoSedeParagrafoMobilitaCondivisa.mimeType};base64,${paragrafo.allegatoSedeParagrafoMobilitaCondivisa.documento}`} alt={paragrafo.allegatoSedeParagrafoMobilitaCondivisa.nome} class="max-h-60 h-auto max-w-full" />
												</div>
											{/if}
										</div>
									{/each}
								</div>
							{/if}
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>2.3</span>
								<span>Analisi degli spostamenti casa-lavoro</span>
							</h1>
							<p>{$data.psclSchemaAnalisi.testoSpostamentiCasaLavoroDipendenti}</p>
							<br />
							<Map bind:this={map} indirizziDipendenti={$data.indirizziDipendenti} sede={$data.sede} bind:mapScreenshot={$data.psclSchemaAnalisi.mapScreenshot} customClass="mt-2"/>
							<h2 class="mb-4 text-sm italic text-center">Localizzazione dei lavoratori rispetto alla sede</h2>
							<div class="w-full mt-4 ml-2">
								<h1 class="text-xl font-bold">
									<span>2.3.1</span>
									<span>Analisi delle modalità abituali di spostamento casa-lavoro e della propensione al cambiamento negli spostamenti casa-lavoro</span>
								</h1>
								<p>{$data.psclSchemaAnalisi.testoAbitudiniEPropensioneCambiamentoSpostamentoCasaLavoro}</p>
								<div class="p-3">
									{#if stringifiedQuestionarioJsonAnalisi && risposteJsonAnalisi?.length > 0}
										<SurveyReport 
											bind:this={surveyReport}
											bind:stringifiedQuestionarioJson={stringifiedQuestionarioJsonAnalisi}
											bind:risposteJson={risposteJsonAnalisi}
											bind:risposteScreenshots={$data.psclSchemaAnalisi.questionarioRisposteScreenshots}
											switchVisualization={true}
											printAnalytics={true}
											customClass="mt-2"
										/>
									{:else if loadingQuestionarioRisposte}
										<ContainerLoading />
									{:else}
										<NoDataAvailable />
									{/if}
								</div>
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-xl font-bold">
								<span>2.4</span>
								<span>Monitoraggio delle misure implementate</span>
							</h1>
							<p>{$data.psclSchemaMonitoraggioMisure?.testoMonitoraggioMisure}</p>
							<div class="p-3">
								<TabellaMonitoraggioMisure data={$data?.psclSchemaMonitoraggioMisure?.programmaMonitoraggioMisure} />
							</div>
						</div>
					</div>
				</StepWizard.Step>
				<StepWizard.Step num="{5}" let:previousStep let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-start col-start-1">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
							</button>
						</div>
						<div class="justify-self-end col-start-2">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
							</button>
						</div>
					</div>
					<div class="flex flex-col items-start justify-start p-4 ml-2">
						<h1 class="text-3xl italic font-bold">
							<span>3.</span>
							<span>Parte progettuale</span>
						</h1>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>3.1</span>
								<span>Progettazione delle misure</span>
							</h1>
							<div class="w-full mt-4 ml-2">
								<h1 class="text-xl font-bold">
									<span>3.1.1</span>
									<span>Descrizione delle misure da implementare</span>
								</h1>
								<p>{$data.psclSchemaProgettazione.testoMisureDaImplementareCategorieMisura}</p>
								<div class="flex justify-center mt-2">
									<div class="mt-2">
										<GraficoOrdinamentoCategorieMisura data={$data?.psclSchemaProgettazione?.ordinamentoCategorieMisure?.categorie}/>
									</div>
								</div>
								<p>{$data.psclSchemaProgettazione.testoMisureDaImplementareMisure}</p>
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaMisure data={$data?.psclSchemaProgettazione?.elencoMisure?.assi}/>
										</div>
									</div>
								</div>
							</div>
							<div class="w-full mt-4 ml-2">
								<h1 class="text-xl font-bold">
									<span>3.1.2</span>
									<span>Definizione dei benefici conseguibili con l'attuazione delle misure</span>
								</h1>
								<p>{$data.psclSchemaProgettazione.testoBeneficiMisureEmissioniInput}</p>
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaCalcoloEmissioniInput data={$data?.psclSchemaProgettazione?.calcoloEmissioniInput?.modalitaCalcoloEmissioni} />
										</div>
									</div>
								</div>
								<p class="mt-2">{$data.psclSchemaProgettazione.testoBeneficiMisureEmissioniOutput}</p>				  
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaCalcoloEmissioniOutput data={$data?.psclSchemaProgettazione?.calcoloEmissioniOutput} />
										</div>
									</div>
								</div>							  
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>3.2</span>
								<span>Programma di implementazione</span>
							</h1>
							<p>{$data.psclSchemaProgettazione.testoProgrammaImplementazione}</p>
							<div class="w-full mt-4">
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaImplementazioneMisure data={$data?.psclSchemaProgettazione?.programmaImplementazione} />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>3.3</span>
								<span>Programma di comunicazione</span>
							</h1>
							<p>{$data.psclSchemaProgettazione.testoProgrammaComunicazione}</p>
							<div class="w-full mt-4">
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaProgrammaComunicazione data={$data?.psclSchemaProgettazione?.programmaComunicazione} />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</StepWizard.Step>
				<StepWizard.Step num="{6}" let:previousStep let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-start col-start-1">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
							</button>
						</div>
						<div class="justify-self-end col-start-2">
							<button disabled={loadingScreenshots} type="submit" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{async () => { 
									loadingScreenshots = true;
									await surveyReport?.getPlotsScreenshots();
									loadingScreenshots = false;
									onSubmit();
									nextStep()
								} }">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
							</button>
							<!--
							<button disabled={loadingScreenshots} type="button" class="btn-green h-14 w-14 sm:h-16 sm:w-16" 
									on:click="{generateWordReport}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">file_download</span>
							</button>
						-->
						</div>
					</div>
					<div class="flex flex-col items-start justify-start p-4 ml-2">
						<h1 class="text-3xl italic font-bold">
							<span>4.</span>
							<span>Programma di monitoraggio</span>
						</h1>
						<div class="w-full mt-4">
							<p>{$data.psclSchemaMonitoraggio.testoProgrammaMonitoraggio}</p>
							<div class="w-full mt-4">
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaProgrammaMonitoraggio data={$data?.psclSchemaMonitoraggio?.programmaMonitoraggio}/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>4.1</span>
								<span>Aggiornamento del piano</span>
							</h1>
							<p>{$data.psclSchemaMonitoraggio.testoAggiornamentoPiano}</p>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>Appendice</span>
							</h1>
							{#if $data?.psclSchemaAppendice?.testoMatriceOD}
								<p>{$data.psclSchemaAppendice.testoMatriceOD}</p>
							{/if}
							<div class="flex justify-center mt-2">
								<div class="w-full">
									<div class="mt-2">
										<TabellaCapComuneDipendenti data={$data.sedeCapComuneDipendente}/>
									</div>
								</div>
							</div>
							<div class="p-3">
								{#if $data?.psclSchemaAppendice?.testoQuestionarioRisposte}
									<p>{$data.psclSchemaAppendice?.testoQuestionarioRisposte}</p>
								{/if}
								{#if $data?.psclSchemaAppendice && stringifiedQuestionarioJsonAppendice && risposteJsonAppendice?.length > 0}
									<SurveyReport bind:this={surveyReport} 
													bind:stringifiedQuestionarioJson={stringifiedQuestionarioJsonAppendice} 
													bind:risposteJson={risposteJsonAppendice} 
													bind:risposteScreenshots={$data.psclSchemaAppendice.questionarioRisposteScreenshots } 
													switchVisualization={true} 
													printAnalytics={true} 
													customClass="mt-2"/>
								{:else}
									<NoDataAvailable />
								{/if}
							</div>
						</div>
					</div>
				</StepWizard.Step>
				<StepWizard.Step num="{7}">
					<div class="p-4">
						{#if $loadingReport}
							<ContainerLoading />
						{:else if !$loadingReport && $dataReport}
						<!--
						<button class="btn-primary mt-4" on:click="{generateWordReport}">
								<span class="material-icons-outlined mr-2">file_download</span>
								Scarica report in formato Word
							</button>
						-->
							<StimulsoftReport reportName="PSCL" urlFile="./assets/reports/PSCLReport-v14.mrt.html" dataSetName="PSCLReport" bind:data="{$dataReport}" />
						{/if}
					</div>
				</StepWizard.Step>
			</StepWizard>
		{/if}
	{/if}
</Card>
